import { useMemo } from 'react';
import { AssetApi } from '../../Assets/models';
import { useAssets } from '../../Assets/hooks';

interface Option {
  label: string;
  data: any;
  key?: string | number;
}

interface UseAssetsOptionsProps {
  search?: string;
  minLength?: number;
  brand?: string;
  model?: string;
  type?: string;
  returnRaw?: boolean;
}

const useAssetsOptions = ({
  search = '',
  minLength = 3,
  brand = '',
  model = '',
  type = '',
  returnRaw = false,
}: UseAssetsOptionsProps = {}) => {
  const shouldSearch = search && search.length >= minLength;

  const { assets, isAssetsLoading } = useAssets({
    filters: {
      typeId: type || '',
      brandId: brand || '',
      modelId: model || '',
      cityId: [],
      userId: [],
    },
    search: shouldSearch ? search : '',
    page: 1,
    pageSize: 1000,
  });

  const assetsOptions = useMemo<Option[]>(() => {
    return assets.map((asset: AssetApi) => ({
      label: `${asset.assetType?.name || ''} - ${asset.brand?.name || ''} ${asset.model?.name || ''} (${asset.id})`,
      data: asset,
      key: asset.id,
    }));
  }, [assets]);

  if (returnRaw) {
    return { assetsOptions, isAssetsLoading, rawAssets: assets };
  }
  return { assetsOptions, isAssetsLoading };
};

export default useAssetsOptions;
